export default __webpack_public_path__ + "static/media/BJ.5ba82301.svg";